import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXS, BrandXXS } from '@sorare/core/src/atoms/typography';
import { CornerBadge, Position } from '@sorare/core/src/components/CornerBadge';

import type { TaskCampaignLabel_taskCampaign } from './__generated__/index.graphql';

const Chip = styled(Horizontal)`
  padding: 2px var(--half-unit);
  border-radius: var(--half-unit);
`;

type Props = {
  taskCampaign: TaskCampaignLabel_taskCampaign;
  variant?: 'cornerBadge' | 'chip';
  align?: Position;
};
export const TaskCampaignLabel = ({
  taskCampaign,
  variant = 'cornerBadge',
  align = Position.LEFT,
}: Props) => {
  const {
    color1 = 'var(--c-nd-600)',
    color2 = 'var(--c-nd-400)',
    tagLabel,
    tagIconUrl,
  } = taskCampaign;
  if (variant === 'chip') {
    return (
      <Chip
        style={{
          background: `linear-gradient(323deg, ${color1} 14.3%, ${color2} 85.7%)`,
        }}
      >
        <img height={10} src={tagIconUrl} alt={tagLabel} />
        <BrandXS color="var(--c-black)">{tagLabel}</BrandXS>
      </Chip>
    );
  }

  return (
    <CornerBadge
      color={`linear-gradient(323deg, ${color1} 14.3%, ${color2} 85.7%)`}
      align={align}
    >
      <img height={10} src={tagIconUrl} alt={tagLabel} />
      <BrandXXS color="var(--c-black)">{tagLabel}</BrandXXS>
    </CornerBadge>
  );
};
TaskCampaignLabel.fragments = {
  taskCampaign: gql`
    fragment TaskCampaignLabel_taskCampaign on TaskCampaign {
      slug
      color1: color(variant: PRIMARY)
      color2: color(variant: SECONDARY)
      name
      tagIconUrl
      tagLabel
    }
  ` as TypedDocumentNode<TaskCampaignLabel_taskCampaign>,
};
